import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { hasPrivilege, getTokenInfo } from "../api/token";
import CloudApiKeyCard from "../components/CloudApiKeyCard";

export default function ChangeCloudApiKey() {
  const navigate = useNavigate();
  const params = useParams();
  const users_edit = hasPrivilege('users_edit') || params.uuid === getTokenInfo().uuid;

  useEffect(() => {
    if (!users_edit) {
      navigate("/");
    }
  }, [navigate, users_edit])

  if (users_edit) {
    const ident = params.uuid;

    return (
      <div>
        <CloudApiKeyCard ident={ident} />
      </div>
    )
  }
}
